import { BehaviorSubject } from 'rxjs';
import axios from 'axios';

import { Tank } from '@/api';
import { FuelEvent } from './models/fuel-event';
import { AllocationSummary } from './models/allocation-summary';

export class FuelAllocationService {
	public summary: BehaviorSubject<AllocationSummary | null> = new BehaviorSubject<AllocationSummary | null>(
		null,
	);

	constructor(private tank: Tank) {}

	public async loadEvents(params: { startTime: number; finishTime: number }): Promise<void> {
		try {
			const { startTime, finishTime } = params;
			const fuelEventsResponse = await axios.post<FuelEvent[]>(
				`${process.env.VUE_APP_API_URL}/farmer/events/tanks/791`,
				{
					entityId: this.tank.id,
					entityType: 'tanks',
					startTime,
					finishTime,
				},
			);
			this.summary.next(new AllocationSummary(fuelEventsResponse.data));
		} catch {
			this.summary.next(null);
		}
	}

	public destroy(): void {
		this.summary.unsubscribe();
	}
}
